var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCheckMarkCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_correctThisIsATick") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83E\\uDDFE-Bets",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_correctThisIsATick"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24,48 C10.7455462,48 0,37.2544538 0,24 C0,10.7455462 10.7455462,0 24,0 C37.2544538,0 48,10.7455462 48,24 C48,37.2544538 37.2544538,48 24,48 Z M15.825479,24.8381849 L20.9903597,29.678521 L31.1970151,16.5563697 C31.7421822,15.8504874 32.7568941,15.7244773 33.4596303,16.2727583 C34.1655126,16.8179254 34.2915227,17.8326373 33.7432417,18.5353734 L22.449124,33.0563818 C21.8661378,33.8063839 20.7663812,33.8946474 20.0730837,33.2454615 L13.6193022,27.1950413 C12.9701405,26.5836988 12.9354756,25.5627187 13.5436719,24.9135489 C14.1550145,24.2643872 15.1759946,24.2297224 15.8251644,24.8379187 L15.825479,24.8381849 Z M24,45.1764706 C35.6942521,45.1764706 45.1764706,35.6942521 45.1764706,24 C45.1764706,12.3057479 35.6942521,2.82352941 24,2.82352941 C12.3057479,2.82352941 2.82352941,12.3057479 2.82352941,24 C2.82352941,35.6942521 12.3057479,45.1764706 24,45.1764706 Z",
    id: "Shape"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckMarkCircle);
export default ForwardRef;